



import toast from 'react-hot-toast';
import favSvg from '../assets/fav.svg';
import logoHeaderSvg from '../assets/logo-header.svg';

// Load html2pdf
const loadHtml2Pdf = () => {
    return new Promise((resolve) => {
        if (window.html2pdf) {
            resolve(window.html2pdf);
            return;
        }

        const script = document.createElement('script');

        script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';

        script.onload = () => resolve(window.html2pdf);

        script.onerror = () => {
            console.error('Failed to load html2pdf');
            resolve(null);
        };

        document.body.appendChild(script);
    });
};

export const downloadInvoicePdf = async (
    order,
    user,
    populatedItems = null
) => {
    // const toastId = toast.loading('Generating Invoice...');

    try {
        const html2pdf = await loadHtml2Pdf();

        if (!html2pdf) {
            console.error('PDF Engine Failed');
            return;
        }

        const items = populatedItems || order.items || [];

        // Totals
        const subtotal =
            order.subtotal !== undefined
                ? order.subtotal
                : items.reduce((sum, item) => {
                    return (
                        sum +
                        Number(item.price || 0) *
                        Number(item.quantity || 1)
                    );
                }, 0);

        const tax =
            order.tax !== undefined
                ? order.tax
                : subtotal * 0.1;

        const discount =
            order.discountAmount !== undefined
                ? order.discountAmount
                : 0;

        const total =
            order.total !== undefined
                ? order.total
                : subtotal + tax - discount;

        // Date
        const orderDate = new Date(
            order.createdAt || Date.now()
        );

        const formattedDate = orderDate.toLocaleDateString(
            'en-US',
            {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }
        );

        const formattedTime = orderDate.toLocaleTimeString(
            'en-US',
            {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            }
        );

        // Invoice Number
        const invoiceNo = order.invoiceNumber || String(
            order.orderId || order._id || 'A3F9E12C'
        )
            .slice(-8)
            .toUpperCase();

        // User
        const clientName = user
            ? `${user.firstName || ''} ${user.lastName || ''
                }`.trim()
            : 'Alex Johnson';

        const clientEmail =
            user?.email || 'alex.johnson@email.com';

        // Convert SVG to Base64
        let favBase64 = favSvg;
        let logoBase64 = logoHeaderSvg;

        try {
            const [favText, logoText] = await Promise.all([
                fetch(favSvg).then((r) => r.text()),
                fetch(logoHeaderSvg).then((r) =>
                    r.text()
                ),
            ]);

            if (favText.includes('<svg')) {
                favBase64 = `data:image/svg+xml;base64,${window.btoa(
                    unescape(
                        encodeURIComponent(favText)
                    )
                )}`;
            }

            if (logoText.includes('<svg')) {
                logoBase64 = `data:image/svg+xml;base64,${window.btoa(
                    unescape(
                        encodeURIComponent(logoText)
                    )
                )}`;
            }
        } catch (err) {
            console.warn('SVG Fallback', err);
        }

        // Product Rows
        const rowsHtml = items
            .map((item, idx) => {
                const game = item.game || {};

                const title =
                    game.title || 'Unknown Game';

                const qty = Number(
                    item.quantity || 1
                );

                const price = Number(
                    item.price || 0
                );
                const platform = item.platform || 'PC';
                const totalPrice = qty * price;

                return `
                <div style="
                    background:#1E1E2869;
                    border:1px solid rgba(255,255,255,0.05);
                    border-radius:14px;
                    padding:10px 18px;
                    margin-bottom:10px;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    position:relative;
                    overflow:hidden;
                ">

                    <div style="
                        position:absolute;
                        inset:0;
                        background:
                        // linear-gradient(
                        //     90deg,
                        //     rgba(0,240,255,0.02),
                        //     transparent,
                        //     rgba(189,0,255,0.02)
                        // );
                    "></div>

                    <div style="
                        display:flex;
                        align-items:center;
                        gap:10px;
                        position:relative;
                        z-index:2;
                    ">

                        <div style="
                            width:28px;
                            font-size:14px;
                            font-family:'Orbitron',sans-serif;
                            font-weight:900;
                            color:#00f0ff;
                            opacity:0.7;
                        ">
                            ${String(idx + 1).padStart(
                    2,
                    '0'
                )}
                        </div>

                        <div>
                            <div style="
                                font-family:'Orbitron',sans-serif;
                                font-size:15px;
                                font-weight:700;
                                color:white;
                                margin-bottom:4px;
                            ">
                                ${title}
                            </div>

                            <div style="
                                font-size:8px;
                                color:#5d5d70;
                                letter-spacing:2px;
                                font-family:'Orbitron',sans-serif;
                            ">
                                ${platform}
                            </div>
                        </div>

                    </div>

                    <div style="
                        text-align:right;
                        position:relative;
                        z-index:2;
                    ">
                        <div style="
                            font-family:'Orbitron',sans-serif;
                            font-size:18px;
                            font-weight:900;
                            color:#00f0ff;
                        ">
                            $${totalPrice.toFixed(2)}
                        </div>

                        <div style="
                            font-size:8px;
                            color:#5d5d70;
                            letter-spacing:1px;
                            margin-top:4px;
                            font-family:'Orbitron',sans-serif;
                        ">
                            QTY × ${qty}
                        </div>
                    </div>

                </div>
            `;
            })
            .join('');

        // =========================
        // PDF WRAPPER
        // =========================

        const wrapper = document.createElement('div');

        wrapper.id = 'invoice-pdf-wrapper';

        wrapper.style.position = 'fixed';
        wrapper.style.top = '-9999px';
        wrapper.style.left = '-9999px';
        wrapper.style.width = '794px';
        wrapper.style.height = '1123px';
        wrapper.style.overflow = 'hidden';

        // =========================
        // MAIN ELEMENT
        // =========================

        const element = document.createElement('div');

        element.style.width = '794px';
        element.style.minHeight = '1123px';
        element.style.background = '#1E1E28';
        element.style.position = 'relative';
        element.style.overflow = 'hidden';

        wrapper.appendChild(element);

        document.body.appendChild(wrapper);

        // =========================
        // HTML
        // =========================

        element.innerHTML = `
        <div style="
            width:794px;
            min-height:1123px;
            background:
            linear-gradient(
                0deg,
                #04040a 0%,
                #050510 35%,
                #1E1E28 100%
            );
            color:white;
            font-family:'Inter',sans-serif;
            padding:55px;
            box-sizing:border-box;
            position:relative;
            overflow:hidden;
        ">

            <style>
                @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
            </style>

            <!-- Watermark -->
            <div style="
                position:absolute;
                inset:0;
                display:flex;
                align-items:center;
                justify-content:center;
                z-index:0;
            ">
                <img
                    src="${favBase64}"
                    style="
                        width:520px;
                        height:520px;
                        object-fit:contain;
                        opacity:0.04;
                        transform:scaleX(-1);
                    "
                />
            </div>

            <!-- Content -->
            <div style="
                position:relative;
                z-index:2;
                min-height:1013px; /* 1123px height - 2*55px padding = 1013px inner height */
                display:flex;
                flex-direction:column;
                justify-content:space-between;
            ">

                <div>
                    <!-- Header -->
                    <div style="
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-start;
                    ">

                        <!-- Left -->
                        <div>

                            <div style="
                                display:flex;
                                align-items:center;
                                gap:14px;
                                margin-bottom:8px;
                            ">

                                <img
                                    src="${logoBase64}"
                                    style="
                                        width:170px;
                                        height:58px;
                                        object-fit:contain;
                                    "
                                />


                            </div>

                        </div>

                        <!-- Right -->
                        <div style="
                            text-align:right;
                        ">

                            <div style="
                                font-size:8px;
                                color:#5d5d70;
                                letter-spacing:2px;
                                font-family:'Orbitron',sans-serif;
                                margin-bottom:4px;
                            ">
                                INVOICE
                            </div>

                            <div style="
                                font-family:'Orbitron',sans-serif;
                                font-size:32px;
                                font-weight:900;
                                margin-bottom:10px;
                            ">
                                <span style="color:#00f0ff;">
                                    #
                                </span>${invoiceNo}
                            </div>

                            <div style="
                                display:inline-flex;
                                align-items:center;
                                gap:6px;
                                padding:7px 14px;
                                border-radius:999px;
                                background:rgba(57,255,20,0.08);
                                border:1px solid rgba(57,255,20,0.2);
                                color:#39ff14;
                                font-size:9px;
                                letter-spacing:1px;
                                font-family:'Orbitron',sans-serif;
                            ">

                                <span style="
                                    width:6px;
                                    height:6px;
                                    border-radius:50%;
                                    background:#39ff14;
                                "></span>

                                COMPLETED
                            </div>

                        </div>

                    </div>

                    <!-- Divider -->
                    <div style="
                        height:1px;
                        margin:28px 0;
                        background:
                        linear-gradient(
                            90deg,
                            #00f0ff,
                            #bd00ff,
                            #ff007a
                        );
                        opacity:0.7;
                    "></div>

                    <!-- Customer -->
                    <div style="
                        background:#08081469;
                        border-radius:14px;
                        border:1px solid rgba(255,255,255,0.04);
                        padding:20px;
                        margin-bottom:24px;
                    ">

                        <div style="
                            color:#00f0ff;
                            font-size:9px;
                            letter-spacing:2px;
                            font-family:'Orbitron',sans-serif;
                            margin-bottom:10px;
                        ">
                            BILLED TO
                        </div>

                        <div style="
                            font-size:16px;
                            font-weight:700;
                            margin-bottom:5px;
                        ">
                            ${clientName}
                        </div>

                        <div style="
                            font-size:12px;
                            color:#777;
                        ">
                            ${clientEmail}
                        </div>

                    </div>

                    <!-- Products -->
                    ${rowsHtml}

                    <!-- Total -->
                    <div style="
                        margin-top:25px;
                        display:flex;
                        justify-content:flex-end;
                    ">

                        <div style="
                            width:320px;
                            background:#05051269;
                            border-radius:16px;
                            border:1px solid rgba(0,240,255,0.25);
                            padding:20px;
                        ">

                            <div style="
                                display:flex;
                                justify-content:space-between;
                                margin-bottom:8px;
                                color:#888;
                                font-size:12px;
                            ">
                                <span>Subtotal</span>
                                <span>$${subtotal.toFixed(
                2
            )}</span>
                            </div>

                            <div style="
                                display:flex;
                                justify-content:space-between;
                                margin-bottom:8px;
                                color:#888;
                                font-size:12px;
                            ">
                                <span>Tax</span>
                                <span>$${tax.toFixed(
                2
            )}</span>
                            </div>

                            <div style="
                                display:flex;
                                justify-content:space-between;
                                margin-bottom:15px;
                                color:#888;
                                font-size:12px;
                            ">
                                <span>Discount</span>
                                <span>
                                    -$${discount.toFixed(2)}
                                </span>
                            </div>

                            <div style="
                                height:1px;
                                background:rgba(255,255,255,0.08);
                                margin-bottom:20px;
                            "></div>

                            <div style="
                                display:flex;
                                justify-content:space-between;
                                align-items:center;
                            ">

                                <div>
                                    <div style="
                                        font-size:10px;
                                        color:#00f0ff;
                                        letter-spacing:2px;
                                        font-family:'Orbitron',sans-serif;
                                        margin-bottom:6px;
                                    ">
                                        TOTAL DUE
                                    </div>

                                    <div style="
                                        font-size:32px;
                                        font-family:'Orbitron',sans-serif;
                                        font-weight:900;
                                        color:#00f0ff;
                                    ">
                                        $${total.toFixed(2)}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

                <!-- Footer -->
                <div style="
                    margin-top:45px;
                    text-align:center;
                    font-family:'Orbitron',sans-serif;
                    font-size:9px;
                    color:#5d5d70;
                    letter-spacing:1px;
                ">
                    © 2026 CUBE GAMES. All rights reserved by YOYO GAMES INC.
                </div>

            </div>

        </div>
        `;

        // WAIT
        await document.fonts.ready;

        await new Promise((resolve) =>
            setTimeout(resolve, 1500)
        );

        // =========================
        // GENERATE PDF
        // =========================

        await html2pdf()
            .set({
                margin: 0,

                filename: `Cube_Games_Invoice_${invoiceNo}.pdf`,

                image: {
                    type: 'jpeg',
                    quality: 1,
                },

                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    logging: false,
                    backgroundColor: '#030305',
                    scrollX: 0,
                    scrollY: 0,
                    imageTimeout: 15000,
                    letterRendering: true,
                },

                jsPDF: {
                    unit: 'px',
                    format: [794, 1123],
                    orientation: 'portrait',
                },
            })
            .from(element)
            .save();

        // CLEANUP
        document.body.removeChild(wrapper);
    } catch (error) {
        console.error(error);
        console.error('Failed To Generate Invoice');
    }
};

export const generateInvoice = async (
    order,
    user,
    action = 'save',
    populatedItems = null
) => {
    return downloadInvoicePdf(
        order,
        user,
        populatedItems
    );
};